import React from "react";
import { Field } from "../../components";
import "./OrganizationsScreen.css";

// The fields of a new organization, in one place.
//
// Used by the New organization dialog on the Organizations screen and by the inline form
// in New assessment. They were two copies, and the second only asked for a name and a
// website — so an organization made from an assessment arrived without its contact
// details. Anything added here appears in both.
//
// The keys are what POST s1/api/create_organization reads.

export const EMPTY_ORGANIZATION = { name: "", website: "", primaryPerson: "", primaryEmail: "", primaryPhone: "" };

/** An error message for the form, or "" when it can be submitted. */
export const validateOrganization = (org) =>
  (org?.name || "").trim() ? "" : "Give the organization a name.";

/** Trimmed, ready to post. */
export const cleanOrganization = (org) =>
  Object.fromEntries(Object.entries({ ...EMPTY_ORGANIZATION, ...org }).map(([k, v]) => [k, String(v ?? "").trim()]));

const OrganizationFields = ({ value, onChange, onSubmit, autoFocus = true, compact = false }) => {
  const set = (k) => (e) => onChange({ ...value, [k]: e.target.value });
  // Enter in any box submits, as a form would — the fields are not inside a <form> in
  // either place, because both sit inside larger dialogs.
  const onKeyDown = (e) => {
    if (e.key === "Enter" && onSubmit) { e.preventDefault(); onSubmit(); }
  };
  const input = (k, props = {}) => (
    <input className="v2-input" value={value[k] || ""} onChange={set(k)} onKeyDown={onKeyDown} {...props} />
  );

  return (
    <div className={`v2-orgfields${compact ? " compact" : ""}`}>
      <div className="v2-orgfields-name">
        <Field label="Name">{input("name", { autoFocus, placeholder: "e.g. Acme Electrical" })}</Field>
      </div>
      <Field label="Website">{input("website", { placeholder: "example.com" })}</Field>

      {/* Grouped and introduced, because three bare boxes labelled "Primary contact",
          "Email" and "Phone" read as the organization's own switchboard details. They
          are one person: the main contact at the organization. */}
      <fieldset className="v2-orgfields-contact">
        <legend>
          Primary contact
          <span>The main person you work with at this organization. Optional.</span>
        </legend>
        <Field label="Contact name">{input("primaryPerson", { placeholder: "e.g. Jordan Lee", autoComplete: "off" })}</Field>
        <Field label="Contact email">{input("primaryEmail", { type: "email", placeholder: "jordan@example.com", autoComplete: "off" })}</Field>
        <Field label="Contact phone">{input("primaryPhone", { type: "tel", autoComplete: "off" })}</Field>
      </fieldset>
    </div>
  );
};

export default OrganizationFields;
